import axis from './axis.svg';
import bob from './bob.svg';
import canara from './canara.svg';
import federal from './federal-bank.svg';
import hdfc from './hdfc.svg';
import icici from './icici.svg';
import sbi from './sbi.svg';
import union from './union.svg';
import yesbank from './yes-bank.svg';

export { axis, bob, canara, federal, hdfc, icici, sbi, union, yesbank };
